import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronRightMedium"><Path d="M9.14645 5.14645C9.34171 4.95118 9.65822 4.95118 9.85348 5.14645L16.3535 11.6464C16.5487 11.8417 16.5487 12.1582 16.3535 12.3535L9.85348 18.8535C9.65822 19.0487 9.34171 19.0487 9.14645 18.8535C8.95118 18.6582 8.95118 18.3417 9.14645 18.1464L15.2929 12L9.14645 5.85348C8.95118 5.65822 8.95118 5.34171 9.14645 5.14645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRightMedium;
